/*
  Accessibility - input-modality tracking (WCAG 2.4.7)
  ----------------------------------------------------------------------------
  The theme's mega-menu programmatically moves focus to nav items on mouse
  hover/click, which makes the browser report :focus-visible even though the
  user is using a pointer. That caused our high-visibility focus ring to flash
  on clicks and hovers.

  This script records the last input modality on <body>:
    - body.using-keyboard  -> set after a navigation/activation key is pressed
    - class removed         -> on any mousedown/touchstart/pointerdown
  The a11y focus ring is scoped to body.using-keyboard so it only appears for
  genuine keyboard navigation, while pointer interactions stay ring-free.
  Keyboard access is never weakened: the ring still shows on Tab/arrow/Enter.
*/
(function () {
  var NAV_KEYS = ['Tab', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight',
    'Enter', ' ', 'Spacebar', 'Escape', 'Home', 'End', 'PageUp', 'PageDown'];
  function keyboard(e) {
    if (NAV_KEYS.indexOf(e.key) !== -1) document.body.classList.add('using-keyboard');
  }
  function pointer() {
    document.body.classList.remove('using-keyboard');
  }
  window.addEventListener('keydown', keyboard, true);
  window.addEventListener('mousedown', pointer, true);
  window.addEventListener('pointerdown', pointer, true);
  window.addEventListener('touchstart', pointer, true);
})();
